export default "__VITE_ASSET__f53a6f50__"